import useAuth from "../../../hooks/useAuth";
import ConfigError from "../ConfigError/ConfigError";

/**
 * Startup gate.
 *
 * Public routes are allowed to render before auth has loaded. Protected
 * routes own their loading states, and a misconfigured production build
 * still gets stopped here as soon as the backend check reports it.
 */
const AppBoot = ({ children }) => {
  const { status, backendMode } = useAuth();

  if (status === "unavailable") {
    return <ConfigError missing={backendMode.missing} />;
  }

  return children;
};

export default AppBoot;
